import { CartContext } from "../../CartContext";
import { useContext, useState } from "react";
import classes from "./CartItem.module.css";
import CartProduct from "../CartProduct";
import { getProductData } from "../../productStore";

const CartItem = (props) => {
  const cart = useContext(CartContext);

  return (
    <div>
      {cart.items.map((item, i) => {
        return (
          <li key={i} className={classes.list}>
            <CartProduct quantity={item.quantity} id={item.id} />
          </li>
        );
      })}
    </div>
  );
};

export default CartItem;
